import { useScrollPageToTop } from '@shared/lib/hooks/use-scroll-page-to-top/use-scroll-page-to-top';
import { LinkProps } from 'react-router-dom';
import { StyledLink } from './link-scroll.styles';

export const LinkScroll: React.FC<LinkProps> = ({ ...props }) => {
    const scrollPageToTop = useScrollPageToTop();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (props.onClick) {
            props.onClick(e);
        }
        scrollPageToTop();
    };

    return <StyledLink {...props} onClick={handleClick} />;
};
